import {useState} from 'react'
import RateCardDetailsForm from './RateCardDetailsForm';
import RateCardDetailsList from './RateCardDetailsList';

const RateCardDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <RateCardDetailsForm addForm={setFromIsShown} update={upData} />
        ) : (
          <RateCardDetailsList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default RateCardDetails